(function () {

	'use strict';

	angular
		.module('AutoPrequal')
		.factory('VehicleFactory', vehicle);

	vehicle.$inject = ['$q', '$http', '$injector', '$rootScope', 'ErrorFactory'];

	function vehicle($q, $http, $injector, $rootScope, ErrorFactory) {

		var lang = "en";
		var sessionId = "";

		var vehicleFactory = {
			autoComplete: autoComplete,
			getVehicle: getVehicle
		};

		return vehicleFactory;

		function autoComplete(model) {
			var deferred = $q.defer();
			$http({
				method: 'POST',
				url: baseUrl + "api/vehicles/autocomplete",
				data: model
			}).then(function (response) {
				var data;
				try { data = JSON.parse(response.data); }
				catch (e) { data = response.data };
				if (data['result_code'] === "0") {
					deferred.resolve(data);
				}
				else {
					$rootScope.ga.errors.blackbookError(data['result_code']);
					ErrorFactory.errorPage(data['result_code'], "en", "Autocomplete failed with response code error", data['result_content']);
					deferred.reject(data['result_code']);
				}
			}, function (httpError) {
				if (httpError.status) {
					ErrorFactory.errorPage("ACE-" + httpError.status, "en", "Autocomplete failed", "Autocomplete failed with http status code error");
				}
				else {
					ErrorFactory.errorPage("ACU", "en", "Autocomplete failed", "Autocomplete failed with unexpected error");
				}
				deferred.reject(httpError);
			})
			return deferred.promise;
		}

		function getVehicle(model) {
			var deferred = $q.defer();
			$http({
				method: 'POST',
				url: baseUrl + "api/vehicles/usedvehicle",
				data: model
			}).then(function (response) {
				var data;
				try { data = JSON.parse(response.data); }
				catch (e) { data = response.data };
				if (data['result_code'] === "0") {
					if (env == "DEV") {
						console.log("UsedVehicle", data.result_content);
					}
					$injector.get('DataFactory').appData.applicant = data.result_content;
					deferred.resolve(data);
				}
				else {
					$rootScope.ga.errors.blackbookError(data['result_code']);
					ErrorFactory.errorPage(data['result_code'], "en", "Get Vehicle failed with response code error", data['result_content']);
					deferred.reject(data['result_code'])
				}
			}, function (httpError) {
				if (httpError.status) {
					ErrorFactory.errorPage("GVE-" + httpError.status, "en", "Get Vehicle failed", "Get Vehicle failed with http status code error");
				}
				else {
					ErrorFactory.errorPage("GVU", "en", "Get Vehicle failed", "Get Vehicle failed with unexpected error");
				}
				deferred.reject(httpError)
			})
			return deferred.promise;
		};
	};
})();
